import React, { useState } from 'react';
import useStyles from './styles';
import { forogtPassword } from '../../services/user.service';
import { ResetEmailModel, NotifyModel } from '../../models/Auth.model';
import { TextField, Button, Typography, CircularProgress } from '@material-ui/core';
import { validateEmail } from '../../shared/validate';
import { variableConstant } from '../../constants/Variable.constant';
import Notify  from '../../shared/Notify';

const ForgotPasswordForm = (props) => {
  const { toggle } = props;
  const classes = useStyles();
  // Local State @author Sagar
  const [userData, setUserData] = useState(ResetEmailModel);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [displayErrorMessage, setDisplayErrorMessage] = useState("");
  const [notifyProps, setNotifyProps] = useState(NotifyModel);

  // Send Reset Email Link @author Sagar
  const handleSubmit = (evt) => {
    evt.preventDefault();
    if (validateEmail(userData)) {
      setError(true);
    } else {
      setError(false);
      setIsLoading(true);
      forogtPassword(userData).then(
        (result) => {
          setIsLoading(false);
          if (result && result.data.statusCode === 200) {
            setUserData(ResetEmailModel);
            setNotifyProps({
              ...notifyProps,
              message: result.data.message,
              type: "success",
              toggle: true,
            });
          } else {
            setError(true);
            setDisplayErrorMessage(result.data.message);
          }
        },
        (error) => {
          setIsLoading(false);
        },
      );
    }
  };
  // Update Form Fileds @author Sagar
  const handleChange = (evt) => {
    let value = evt.target.value;
    setError(false);
    setDisplayErrorMessage("");
    setUserData({
      ...userData,
      [evt.target.name]: value,
    });
  };
  // Reset Email Form Design @author Sagar
  return (
    <div className={classes.formSection}>
      <div className={classes.formTitle}>
        <Typography variant="h5" className={classes.loginTitle}>
          {"Forgot Password"}
        </Typography>
      </div>
      <form onSubmit={handleSubmit}>
        <div className={`form-group ${classes.passwordFormGroup}`}>
          <TextField
            error={error}
            id="reset-email"
            label="Email"
            variant="outlined"
            size="small"
            name="emailId"
            value={userData.emailId}
            onChange={handleChange}
            fullWidth
          />
        </div>
        <div className={`form-group ${classes.emailFormGroup}`}>
          <p className={classes.errorTextStyle}>
            {displayErrorMessage ? displayErrorMessage : null}
          </p>
        </div>
        <div className={`form-group ${classes.backToLoginFormGroup}`}>
          <div
            onClick={toggle}
            color="primary"
            size="large"
            className={classes.forgetLink}
          >
            {variableConstant.goToLogin}
          </div>
        </div>
        <div className={`form-group ${classes.loginFormGroup}`}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            type="submit"
            className={classes.loginButton}
            disabled={isLoading}
          >
            {!isLoading ? (
              <span>{"Submit"}</span>
            ) : (
              <span>
                {" "}
                <CircularProgress size={26} />
              </span>
            )}
          </Button>
        </div>
      </form>
      <Notify notifyProps={notifyProps} />
    </div>
  );
};

export default ForgotPasswordForm;
